import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import logo from '../../../image/logo.PNG';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles({
  paper: {
    background: '#f4d700',
    color: '#000000',
    paddingLeft: '10px',
  },
});

const AppTitleCard: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <Box display="flex" justifyContent="flex-start" alignItems="center">
        <img src={logo} alt="picture" width="120px" height="30px" />
        <Typography variant="h6">{t('AppTitleCard.回転機診断Webシステム', '回転機診断Webシステム')}</Typography>
      </Box>
    </Paper>
  );
};

export default AppTitleCard;
